import React, { useMemo } from 'react';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import { TEMPLATE_OPTION_TYPE } from './new-shopper-options/constants';
import style from './style.module.less';
import { FilterEditorContextProvider } from '../../../../../components/filter-editor/context';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../../../hooks/use-has-rate-shopper-access-level';
import { useModal } from '../../../../../hooks/use-modal';
import { AutomationRulesProvider } from '../../../../../pages/settings/automation-rules/context';
import AutomationRulesModalManager from '../../../automation-rules/modals/modal-manager';
import { SettingsPageTitle } from '../../../components/settings-page-title/settings-page-title';
import { useRateShopperContext } from '../../context/rate-shopper-context';
import { AddShopperButton } from '../add-shopper-button';
import { RateShopperFreemiumBanner } from '../freemium-banner';
import { RateShopperDrawer } from '../rate-shopper-drawer';
import { ShopperCollection } from '../shopper-collection';

const emptyShopperForPackageAndConfirmation = {
  services: [
    {
      carrierId: '',
      packageTypeId: '',
      providerId: '',
      sellerProviderId: '',
      shippingServiceId: '',
    },
  ],
};

const emptyShopper = { services: [] };

export const RateShopperPageComponent = () => {
  const { rateShoppers, refreshServiceCollections, templateOptionType, usePackageAndConfirmation } = useRateShopperContext();
  const { isOpen: isAddShopperOpen, open: openAddShopper, close: closeAddShopper } = useModal();
  const hasPremiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.PREMIUM);
  const standardTemplateServices = rateShoppers.find((rs) => rs.isTemplate)?.services;
  const shopperForFeature = usePackageAndConfirmation ? emptyShopperForPackageAndConfirmation : emptyShopper;

  const newShopper = hasPremiumAccess ? shopperForFeature : rateShoppers.find((rs) => rs.isTemplate) || emptyShopper;

  const showFreemiumBanner = !hasPremiumAccess;

  const shopperWithServices = useMemo(() => {
    return { services: [...(standardTemplateServices || [])] };
  }, [standardTemplateServices]);

  const shopperToUse = templateOptionType === TEMPLATE_OPTION_TYPE ? shopperWithServices : newShopper;

  return (
    <FlexRow className={style.content}>
      <div className={style['rate-shoppers']}>
        {isAddShopperOpen ? <RateShopperDrawer isReadOnly={!hasPremiumAccess} onClose={closeAddShopper} shopper={shopperToUse} /> : null}
        <SettingsPageTitle value={messages.title} />
        <Text className={style['first-description']} textType={TextType.Paragraph} value={messages.subHeading} />
        {showFreemiumBanner ? <RateShopperFreemiumBanner className={style.upsell} /> : null}
        <FlexRow className={style['collection-heading']}>
          <Text textType={TextType.H3} value={messages.rateShopperCollectionHeading} />
          <AddShopperButton onClick={openAddShopper} />
        </FlexRow>
        <AutomationRulesProvider onRuleChange={refreshServiceCollections}>
          <FilterEditorContextProvider>
            <AutomationRulesModalManager />
            <ShopperCollection shoppers={rateShoppers} />
          </FilterEditorContextProvider>
        </AutomationRulesProvider>
      </div>
    </FlexRow>
  );
};
